import gsap from 'gsap/all';
import { ScrollTrigger } from 'gsap/all';
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

export class Animation {
    constructor() {

        this.transitionDom = document.querySelector('.transitionContainer')

        this.TL;
        

        gsap.registerPlugin(ScrollTrigger);
       
        
    }



    loading(min, max, mob) {
     

       


        this.TLReverse = gsap.timeline({
            paused: true,
            onComplete: () =>{ 

                gsap.delayedCall(0.5, ()=> {
                    this.loaded(mob) 
                })
                
               
            }}
        );

        this.TLReverse.to('.card-container', {
            duration: 0.4,
            opacity: 1,
            // scale: 0.8,
            ease: "power2.out",
            stagger: {
                each: 1.3,
               
            },
        })

        this.TLReverse.to('.skip', {
            duration: 0.4,
            opacity: 1,
            y:0,
            ease: "power2.out",
           
        },0.5)

      
       
        this.TLReverse.play();

        document.querySelector('.skip-btn').addEventListener('click', ()=> {
            this.TLReverse.pause();
            this.loaded(mob, true)
        })

    }

    loaded(mob, skip) {

        const results = Splitting({
            target: "[data-splitting]",
            by: "chars",
        });


        this.TL = gsap.timeline({paused: true});

        this.allBtns = document.querySelectorAll('.flip-card')
      
        // 200 100 50

        for (let i = 0; i < this.allBtns.length; i++) {
    
            const el = this.allBtns[i]
       
            el.addEventListener('click', ()=> {
                gsap.to(el.children[0], {
                    duration: 0.4,
                    rotationY: "+=180",
                    ease: "power2.out",  
                    
                })
            })
   
            
        }

        if(skip) {
            this.TL.to('.card-container', {
                duration: 0.4,
                opacity: 1,
                // scale: 0.8,
                ease: "power2.out",
                
            }, 0.5)
        }

       
       
        this.TL.to('.flip-card', {
                opacity:1,
                duration: 0.6,
                height: "110px",
                width: "110px",
                fontSize: "14px",
                ease: "power2.out",
                cursor: 'pointer',
           
        },2.5)

       
        this.TL.to('.skip', {opacity:0, ease: "power2.out", duration: 0.4}, 1)
        this.TL.add(()=> {if(document.querySelector('.skip')) {document.querySelector('.skip').remove()}}, 1.4)
       
        this.TL.to('.container-bulles', { height: mob.h, ease: "power2.out", duration: 1}, 1)
        this.TL.to(['.card-container1', '.card-container6'], { duration:0.4, x:0, marginLeft:0, marginBottom:0, marginTop:0, marginRight:0, y: mob.y1, ease: "power2.out"}, 1)
         this.TL.to(['.card-container2', '.card-container5'], { duration:0.4, x:0, marginLeft:0, marginBottom:0, marginTop:0, marginRight:0, y: mob.y2, ease: "power2.out"}, 1)
         this.TL.to(['.card-container3', '.card-container4'], { duration:0.4, x:0, marginLeft:0, marginBottom:0, marginTop:0, marginRight:0,y: mob.y3, ease: "power2.out"}, 1)
        
      

        this.TL.to('.flip-card-inner', {
            duration: 0.4,
            rotationY: 180,
            // scale: 0.8,
            ease: "power2.out",
            stagger: {
                each: 0.1,
               
            },
           
        },1)
        

        this.TL.to('.hero .logo', { duration: 1, y: 0, opacity: 1, ease: "power2.out"}, 1.9)
        this.TL.to(['.hero h1', '.char'], { duration:1.2, opacity: 1, stagger: 0.1, y: 0, opacity: 1,ease: "power2.out"}, 2.5)
        this.TL.to('.start', { duration:0.1,visibility:"visible", ease: "power2.inOut"}, 3.4)
        this.TL.to('.start', { duration:0.4, y: 0, scale:1, opacity: 1, ease: "power2.inOut"}, 3.5)
        this.TL.to('.col-bottom', { duration:0.2, y: 0, opacity: 1, ease: "power2.inOut"}, 4)
        this.TL.play();
    }


   

    homepage(hero, section, game) {
        this.TL = gsap.timeline({paused: true});
        this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(0 0, 100% 0, 100% 100%, 0 100%)"}, 0)
        this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)"}, 1)
        this.TL.to('.loader', { duration: 0.7, ease:'power0.easeOut', opacity: 0}, 1.1)
        this.TL.to('.loader', { visibility: "hidden"}, 1.1)
        this.TL.to('.gameWrapper', { duration: 1, display: "block"}, 1.1)
        this.TL.add(()=> { hero.remove()}, 1)
        this.TL.add(()=> { section.style.display = "flex"}, 1)

      
        if(game === 1) {
            this.TL.to(['.jeu-1 .phrase', '.jeu-1 .source'], { duration: 0.2, ease:'power0.easeIn', y: 10, opacity: 1}, 1.4)
            this.TL.to('.slider-container', { duration: 0.4, ease:'power0.easeIn', scale: 1, opacity: 1}, 1.6)
        }


        else if(game === 2) {

            this.TL.to(['.jeu-2 .phrase', '.jeu-2 .source'], { duration: 0.2, ease:'power0.easeIn', y: 20, opacity: 1}, 1.4)
     
            this.TL.to(".jeu-2 .qcmZone .qcm-btn", {
                y: 10,
                opacity: 1,
                ease: "power1.Out",
                // scale: 0.9,
                stagger: 0.2,
            }, 1.7);
        }

      

        else if(game === 3) {
           
            this.TL.to(['.jeu-3 .phrase', '.jeu-3 .source'], { duration: 0.1, ease:'power2.easeIn', scale: 1.1, x: 5}, 1.4)
            this.TL.to(['.jeu-3 .phrase', '.jeu-3 .source'], { duration: 0.3, ease:'power2.easeIn', scale: 1, opacity: 1, x: -5}, 1.5)

            this.TL.to([".jeu-3 .qcmWrapper .qcmZone .son-container", ".jeu-3 .qcmWrapper .qcmZone .qcm-btn"], {
                opacity: 1,
                ease: "power1.Out",
                scale: 0.9,
                stagger: 0.1,
            }, 1.7);
        }


        else if(game === 4) {

          
            this.TL.to(".jeu-4 .draggable4 .drag4", {
                y: 0,
                opacity: 1,
                ease: "power1.Out",
                stagger: 0.1,
                onComplete:() => {
                    this.TL.to('.jeu-4 .source', { duration: 0.2, ease:'power0.easeIn', y: 0, opacity: 1})
                    this.TL.to('.ponctuationZone4', { duration: 0.4, ease:'power0.easeOut', opacity: 1})
                }
            }, 1.4);
        }

        else if(game === 5) {
     
            this.TL.to(['.jeu-5 .phrase', '.jeu-5 .source', '.drag5'], { duration: 0.2, ease:'power2.easeOut', opacity: 1}, 1.4)
        }




        else if(game === 6) {
     
            this.TL.to('.jeu-6 .phrase', { duration: 0.1, ease:'power2.easeIn', scale: 1.1}, 1.4)
            this.TL.to(['.jeu-6 .phrase', '.jeu-6 .source'], { duration: 0.3, ease:'power2.easeOut', scale: 1, opacity: 1}, 1.5)
       
            this.TL.to(".jeu-6 .qcmWrapper .qcmZone .flag", {
                y: 0,
                opacity: 1,
                ease: "power2.Out",
                scale: 1.1,
                stagger: 0.2,
            }, 1.7);
        }


    
      
        this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(0 0, 100% 0, 100% 0, 0 0)"}, 2)
        this.TL.play();
    }
    

    staggerEl() {
        this.TL = gsap.timeline({paused: true});
        this.TL.to(".c1", {
            opacity: 1,
            ease: "power2.inOut",
            stagger: {
               
                each: 0.5, 
                onComplete: function() {
                    // console.log(this.targets()[0].children[0])
                    //fade out each target when it completes
                    // gsap.to(this.targets()[0].children[0], { opacity:0, ease: "power2.out"})
                }
            },
            onComplete:() => {
                      
                this.TL.to('.mauvaise-rep-view .words-count', { duration: 0.4, ease:'power0.easeOut', opacity: 1, y: 0})
            }
            
        });
        this.TL.play();
    }

    recapEl(view, gameId) {
        this.TL.to(`${view} .mention`, { duration: 0.4, ease:'power0.easeOut', opacity: 1, y: 0, yPercent:0}, 1.5)
        this.TL.to(`${view} .container-reponse`, { duration: 0.5, ease:'power0.easeOut', opacity: 1, y: 0, x:0}, 1.6)
        this.TL.to(`${view} .container-ggf`, { duration: 0.4, ease:'power0.easeOut', opacity: 1, x: 0}, 1.8)
        
        
        if(gameId === 1) {
            this.TL.to(`${view} .container-reponse`, { duration: 0.5, ease:'power0.easeOut', opacity: 1, y: 0, x:0}, 1.6)
            this.TL.to(`${view} .container-ggf`, { duration: 0.4, ease:'power0.easeOut', opacity: 1, x: 0}, 1.8)
        }   

        if(gameId === 1 && view === ".bonne-rep-view") {
            this.TL.to('.bonne-rep-view .words-count', { duration: 0.4, ease:'power0.easeOut', opacity: 1, y: 0})
          
        } else if(gameId === 3) {
            this.TL.to(`${view} .container-response-ggf-three`, { duration: 0.5, ease:'power0.easeOut', opacity: 1, y: 0, x:0}, 1.6)

        } else if(gameId === 5) {
            this.TL.to(`${view} .container-reponse`, { duration: 0.5, ease:'power0.easeOut', opacity: 1, y: 0, x:0}, 1.6)
            this.TL.to(`${view} .container-response-ggf`, { duration: 0.4, ease:'power0.easeOut', opacity: 1, x: 0}, 1.8)
        } 
        else if(gameId === 6) {
            this.TL.to(`${view} .container-reponse`, { duration: 0.5, ease:'power0.easeOut', opacity: 1, y: 0, x:0}, 1.6)
            this.TL.to(`${view} .container-ggf`, { duration: 0.4, ease:'power0.easeOut', opacity: 1, x: 0}, 1.8)
        }
       

        if(view === '.good-rep-view') {
            this.TL.to(`${view} .nxt-rcap`, { duration: 0.4, ease:'power0.easeIn', opacity: 1}, 2.2)
        } else {
            this.TL.to(`${view} .nxt-rcap`, { duration: 0.4, ease:'power0.easeIn', opacity: 1}, 2.2)
        }
    }

    endGame(view, gameId) {
        this.TL = gsap.timeline({paused: true});
        this.TL.to(this.transitionDom, { duration: 0, "clipPath": "polygon(0 0, 0% 0, 0% 100%, 0% 100%)"}, 0)
        this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(0 0, 100% 0, 100% 100%, 0% 100%)"}, 0.1)
        this.TL.to('.gameWrapper', { duration: 0.1, display: "none"}, 1)
        this.TL.to(view, { opacity: 1, visibility: 'visible', display: 'flex',  duration: 0, ease: "power0.easeIn"}, 1.1);
        this.TL.add(() => { window.scrollTo(0, 0); }, 1.1)
        this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(100% 0, 100% 0, 100% 100%, 100% 100%)"}, 1.1)
    
    
        this.recapEl(view, gameId)
    
        this.TL.play();
    }   

    hidePastille(pastille) {
        this.TL = gsap.timeline({paused: true});
        
        this.TL.to('.pastille-container', { duration: 0.5, opacity: 0, scale: 0.1, ease: "power2.out", zIndex:-1}, 0)
        this.TL.add(()=> {pastille.remove()})
        this.TL.play();
    }

    deletePunctuationBtn(btn) {
        this.TL = gsap.timeline({paused: true});
        this.TL.to('.pastille-container', { duration: 0.5, opacity: 0, scale: 0.1, ease: "power2.out"}, 0)
        this.TL.play();
    }


    openPastille() {
        this.TL = gsap.timeline({paused: true});
       
        this.TL.to('.pastille-container', { duration: 0.5, top: "150px",  left: "50%", x: '-50%', y: '-50%', opacity: 0, scale: 0.1, ease: "power2.out"}, 0)
        this.TL.to('.gameWrapper', { duration: 0.2, opacity: 0.1, ease: "power2.out"}, 0.2)
        this.TL.to('.pastille-content', { duration: 0.6, zIndex:2, "clipPath": "circle(71%)", ease: "power2.out"}, 0)
        this.TL.to(['.pastille-content .box', '.pastille-content .box p', '.pastille-content .box button'], { duration: 0.5, opacity: 1, ease: "power2.in"}, 0.8)
      
        this.TL.play();
    }

    closePastille() {
        this.TL = gsap.timeline({paused: true});
        this.TL.to(['.pastille-content .box', '.pastille-content .box p', '.pastille-content .box button'], { duration: 0.5, opacity: 0, ease: "power2.out"}, 0)
        this.TL.to('.pastille-content', { duration: 0.4, zIndex: -1, "clipPath": "circle(0%)", ease: "power2.out"}, 0.3),
        this.TL.to('.gameWrapper', { duration: 0.2, opacity: 1, ease: "power2.in"}, 0.3)
        this.TL.to('.pastille-container', { duration: 0.4, opacity: 1, scale: 1, ease: "power2.out"}, 1)
        
        this.TL.play();
    }

    nextGame(view, game) {

        this.TL = gsap.timeline({paused: true});

       
            this.TL.to(this.transitionDom, { duration: 0, "clipPath": "polygon(0 0, 100% 0, 100% 0, 0 0)"},0)
            this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(0 0, 100% 0, 100% 100%, 0 100%)"}, 0.1)
            this.TL.to(`.mauvaise-rep-view .nxt-rcap`, { duration: 0.1, ease:'power0.easeIn', opacity:0}, 1.1)
            this.TL.to(`.bonne-rep-view .nxt-rcap`, { duration: 0.1, ease:'power0.easeIn', opacity:0}, 1.1)
            this.TL.to(view, { opacity: 0, visibility: 'hidden', display: 'none', duration: 0, ease: "power0.easeIn"}, 1.1);
            this.TL.to('.gameWrapper', { display: 'block', duration: 1, ease: "power0.easeIn"}, 1.1);
            this.TL.to(game, { opacity: 1, display: 'flex', duration: 1, ease: "power0.easeIn"}, 1.1);

            this.TL.add(() => { window.scrollTo(0, 0); }, 1.1)

            if(game === '.recap') {
                this.TL.to(".stg-end", {
                    y: 0,
                    opacity: 1,
                    ease: "power2.inOut",
                    // scale: 0.9,
                    stagger: 0.4,
                }, 1.7);        
            }

            if(game === '.jeu-1') {
                this.TL.to(['.jeu-1 .phrase', '.jeu-1 .source'], { duration: 0.2, ease:'power0.easeIn', y: 10, opacity: 1}, 1.4)
                this.TL.to('.slider-container', { duration: 0.4, ease:'power0.easeIn', scale: 1, opacity: 1}, 1.6)
            }


            else if(game === '.jeu-2') {

                this.TL.to(['.jeu-2 .phrase', '.jeu-2 .source'], { duration: 0.2, ease:'power0.easeIn', y: 20, opacity: 1}, 1.4)
         
                this.TL.to(".jeu-2 .qcmZone .qcm-btn", {
                    y: 10,
                    opacity: 1,
                    ease: "power1.Out",
                    // scale: 0.9,
                    stagger: 0.2,
                }, 1.7);
            }
    
          
    
            else if(game === '.jeu-3') {
               
                this.TL.to(['.jeu-3 .phrase', '.jeu-3 .source'], { duration: 0.1, ease:'power2.easeIn', scale: 1.1, x: 5}, 1.4)
                this.TL.to(['.jeu-3 .phrase', '.jeu-3 .source'], { duration: 0.3, ease:'power2.easeIn', scale: 1, opacity: 1, x: -5}, 1.5)
    
                this.TL.to([".jeu-3 .qcmWrapper .qcmZone .son-container", ".jeu-3 .qcmWrapper .qcmZone .qcm-btn"], {
                    opacity: 1,
                    ease: "power1.Out",
                    scale: 0.9,
                    stagger: 0.1,
                }, 1.7);
            }
    
    
            else if(game === '.jeu-4') {

            
                this.TL.to(".jeu-4 .draggable4 .drag4", {
                    y: 0,
                    opacity: 1,
                    ease: "power1.Out",
                    stagger: 0.1,
                    onComplete:() => {
                        this.TL.to('.jeu-4 .source', { duration: 0.2, ease:'power0.easeIn', y: 0, opacity: 1})
                        this.TL.to('.ponctuationZone4', { duration: 0.4, ease:'power0.easeOut', opacity: 1})
                    }
                }, 1.4);
              
            }
    
            else if(game === '.jeu-5') {
         
                this.TL.to(['.jeu-5 .phrase', '.jeu-5 .source', '.drag5'], { duration: 0.2, ease:'power2.easeOut', opacity: 1}, 1.4)
            }
    
    


            else if(game === '.jeu-6') {
         
                this.TL.to('.jeu-6 .phrase', { duration: 0.1, ease:'power2.easeIn', scale: 1.1}, 1.4)
                this.TL.to(['.jeu-6 .phrase', '.jeu-6 .source'], { duration: 0.3, ease:'power2.easeOut', scale: 1, opacity: 1}, 1.5)
           
                this.TL.to(".jeu-6 .qcmWrapper .qcmZone .flag", {
                    y: 0,
                    opacity: 1,
                    ease: "power2.Out",
                    scale: 1.1,
                    stagger: 0.2,
                }, 1.7);
            }
    
    
    
            this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(0 100%, 100% 100%, 100% 100%, 0 100%)"}, 1.1)
            this.TL.to(this.transitionDom, { duration: 1, ease:'power0.easeIn', "clipPath": "polygon(0 0, 100% 0, 100% 0, 0 0)"}, 2.1)
      

        this.TL.play();
        
       

    }


   
}